import { RootState } from 'src/store';

import { IPaymentForm, IPaymentRoutingData } from '../paymentRouting/types';

export const selectPayoutRoutingData = (state: RootState): Partial<IPaymentRoutingData> => state.payoutRouting.routing.data;
export const selectPayoutRoutingLoading = (state: RootState): boolean => state.payoutRouting.routing.isLoading;
export const selectPayoutRoutingLoaded = (state: RootState): boolean => state.payoutRouting.routing.isLoaded;
export const selectPayoutRouteData = (state: RootState): Partial<IPaymentForm> => state.payoutRouting.route.data;
export const selectPayoutRouteLoading = (state: RootState): boolean => state.payoutRouting.route.isLoading;
export const selectPayoutRouteLoaded = (state: RootState): boolean => state.payoutRouting.route.isLoaded;
